import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedComponent } from './components/shared/shared.component';
import { SharedRoutingModule } from './shared-routing.module';
import { HeaderComponent } from './components/header/header.component';
import { MenuItemComponent } from './components/sidebar/menu-item/menu-item.component';
import { SubSidebarComponent } from './components/sidebar/sidebar/sub-sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { HasPermissionsDirective } from './directives/has-permissions.directive';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { ExpirationDialogComponent } from './components/expiration-dialog/expiration-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';

@NgModule({
  declarations: [
    SharedComponent,
    HeaderComponent,
    MenuItemComponent,
    SubSidebarComponent,
    FooterComponent,
    ConfirmationDialogComponent,
    LandingPageComponent,
    ExpirationDialogComponent,
    HasPermissionsDirective,
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MatDialogModule,
    FormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ReactiveFormsModule,
  ],
  exports: [
    SharedComponent,
    HeaderComponent,
    MenuItemComponent,
    SubSidebarComponent,
    FooterComponent,
    ConfirmationDialogComponent,
    HasPermissionsDirective,
  ],
  providers: [DatePipe],
})
export class SharedModule {}
